import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WebService\FindSimilarInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/FindSimilarInShutterStockController.php
* @route '/api/webservice/shutterstock/{id}/similar'
*/
const FindSimilarInShutterStockController = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FindSimilarInShutterStockController.url(args, options),
    method: 'get',
})

FindSimilarInShutterStockController.definition = {
    methods: ["get","head"],
    url: '/api/webservice/shutterstock/{id}/similar',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WebService\FindSimilarInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/FindSimilarInShutterStockController.php
* @route '/api/webservice/shutterstock/{id}/similar'
*/
FindSimilarInShutterStockController.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return FindSimilarInShutterStockController.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WebService\FindSimilarInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/FindSimilarInShutterStockController.php
* @route '/api/webservice/shutterstock/{id}/similar'
*/
FindSimilarInShutterStockController.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: FindSimilarInShutterStockController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WebService\FindSimilarInShutterStockController::__invoke
* @see app/Http/Controllers/WebService/FindSimilarInShutterStockController.php
* @route '/api/webservice/shutterstock/{id}/similar'
*/
FindSimilarInShutterStockController.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: FindSimilarInShutterStockController.url(args, options),
    method: 'head',
})

export default FindSimilarInShutterStockController